import * as React from 'react';

import { useRouter } from 'next/router';

import { getRoutingPath, ROUTES } from '@itp/talent/constants/routingPath';

export const HomePage: React.FC = () => {
  const router = useRouter();

  React.useEffect(() => {
    router.replace(getRoutingPath(ROUTES.SIGN_IN));
  }, [router]);

  return null;
};
